import { render, staticRenderFns } from "./BestAthletesEventOrderAdmin.vue?vue&type=template&id=146b7885&scoped=true&"
import script from "./BestAthletesEventOrderAdmin.vue?vue&type=script&lang=ts&"
export * from "./BestAthletesEventOrderAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./BestAthletesEventOrderAdmin.vue?vue&type=style&index=0&id=146b7885&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146b7885",
  null
  
)

export default component.exports